/**
 * Builds a portable MJML document from a template draft (visual parity is best-effort).
 * Paste into https://mjml.io/try-it-live or your MJML pipeline.
 */

function esc(s) {
  return String(s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function escAttr(s) {
  return esc(s).replace(/\n/g, " ");
}

function mjTextInner(html, plain) {
  if (html && String(html).trim()) {
    return `<mj-text>${String(html).trim()}</mj-text>`;
  }
  const p = esc(plain || "").replace(/\n/g, "<br/>");
  return `<mj-text><p>${p}</p></mj-text>`;
}

function mjHeadingInner(block) {
  if (block.html && String(block.html).trim()) {
    return `<mj-text>${String(block.html).trim()}</mj-text>`;
  }
  return `<mj-text><h1 style="margin:0;font-size:28px;line-height:1.15;color:#111827;font-weight:600">${esc(block.content || "Heading")}</h1></mj-text>`;
}

/**
 * @param {{ name?: string, blocks?: Array<Record<string, unknown>> }} draft
 */
export function exportTemplateToMjml(draft) {
  const blocks = Array.isArray(draft?.blocks) ? draft.blocks : [];
  const title = esc(draft?.name || "Email template");

  const lines = [
    "<mjml>",
    "  <mj-head>",
    `    <mj-title>${title}</mj-title>`,
    "    <mj-attributes>",
    '      <mj-all font-family="Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif" />',
    "      <mj-text font-size=\"15px\" line-height=\"1.65\" color=\"#374151\" />",
    "    </mj-attributes>",
    "  </mj-head>",
    '  <mj-body background-color="#f3f4f6">'
  ];

  for (const block of blocks) {
    const type = String(block.type || "text");

    if (type === "columns") {
      lines.push('    <mj-section background-color="#ffffff" padding="16px">');
      lines.push('      <mj-column width="50%">');
      lines.push(`        ${mjTextInner(block.html, block.content)}`);
      lines.push("      </mj-column>");
      lines.push('      <mj-column width="50%">');
      lines.push(`        ${mjTextInner(block.rightHtml, block.rightContent)}`);
      lines.push("      </mj-column>");
      lines.push("    </mj-section>");
      continue;
    }

    lines.push('    <mj-section background-color="#ffffff" padding="16px 24px">');
    lines.push("      <mj-column>");

    switch (type) {
      case "heading":
        lines.push(`        ${mjHeadingInner(block)}`);
        break;
      case "image":
        if (block.content) {
          lines.push(`        <mj-image src="${escAttr(block.content)}" fluid-on-mobile="true" alt="" />`);
        }
        break;
      case "video":
        if (block.content) {
          lines.push(`        <mj-text><a href="${escAttr(block.content)}">Watch video</a></mj-text>`);
        }
        break;
      case "audio":
        if (block.content) {
          lines.push(`        <mj-text><a href="${escAttr(block.content)}">Listen</a></mj-text>`);
        }
        break;
      case "button": {
        const href = escAttr(block.href || "#");
        const label = esc(block.content || "Button");
        lines.push(`        <mj-button href="${href}" background-color="#0078d4" color="#ffffff" border-radius="8px" inner-padding="12px 24px">${label}</mj-button>`);
        break;
      }
      case "divider":
        lines.push('        <mj-divider border-color="#e5e7eb" padding="12px 0" />');
        break;
      case "code":
        lines.push(`        <mj-text><pre style="font-size:12px;background:#111;color:#a7f3d0;padding:12px;border-radius:6px;overflow:auto">${esc(block.content || "")}</pre></mj-text>`);
        break;
      case "logo":
        lines.push('        <mj-text><span style="display:inline-block;width:40px;height:40px;background:#e5e7eb;border-radius:6px"></span></mj-text>');
        break;
      default:
        lines.push(`        ${mjTextInner(block.html, block.content)}`);
    }

    lines.push("      </mj-column>");
    lines.push("    </mj-section>");
  }

  lines.push("  </mj-body>");
  lines.push("</mjml>");
  return lines.join("\n");
}
